import { render, staticRenderFns } from "./OutsourcingEditPersonPage.vue?vue&type=template&id=32105255&"
import script from "./OutsourcingEditPersonPage.vue?vue&type=script&lang=js&"
export * from "./OutsourcingEditPersonPage.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingEditPersonPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports